import React from 'react';

import { FlightPageContext } from '../FlightsScreen';


type PageContext = 'everest' | 'all' | 'jomsom' | 'ramechhap'; //  | 'pokhara' 

export default function useFlightPageContext() {
  const pageContext: PageContext = React.useContext(FlightPageContext);
  const flightDataModule = require(`./${pageContext}`);

  return flightDataModule.default;
}



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/useFlightPageContext.js